var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border rounded-sm py-5 text-center"},[_vm._m(0),_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"ri-error-warning-line",staticStyle:{"font-size":"80px","line-height":"1.2"}})])
}]

export { render, staticRenderFns }